/**
 * StatsBar Component - MAX AET Design
 * Displays statistics about the lexicon
 */

import React from "react";
import type { Language, LexikonStatistics } from "../types";

interface StatsBarProps {
  statistics: LexikonStatistics;
  language: Language;
}

const StatsBar: React.FC<StatsBarProps> = ({ statistics, language }) => {
  const labels = {
    cs: {
      total: "pojmů",
      beginner: "Začátečník",
      intermediate: "Pokročilý",
      advanced: "Expert",
      courses: "minikurzů",
    },
    en: {
      total: "terms",
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced",
      courses: "minicourses",
    },
  };

  const t = labels[language];

  return (
    <div className="stats-bar">
      <div className="stats-item">
        <span className="stats-item-icon">📚</span>
        <span className="stats-item-value">{statistics.totalTerms}</span>
        <span>{t.total}</span>
      </div>

      <div className="stats-item">
        <span className="stats-item-icon" style={{ color: "var(--level-beginner)" }}>●</span>
        <span className="stats-item-value">{statistics.byLevel.Beginner}</span>
        <span>{t.beginner}</span>
      </div>

      <div className="stats-item">
        <span className="stats-item-icon" style={{ color: "var(--level-intermediate)" }}>●</span>
        <span className="stats-item-value">{statistics.byLevel.Intermediate}</span>
        <span>{t.intermediate}</span>
      </div>

      <div className="stats-item">
        <span className="stats-item-icon" style={{ color: "var(--level-advanced)" }}>●</span>
        <span className="stats-item-value">{statistics.byLevel.Advanced}</span>
        <span>{t.advanced}</span>
      </div>

      <div className="stats-item">
        <span className="stats-item-icon">🎓</span>
        <span className="stats-item-value">{statistics.totalMiniCourses}</span>
        <span>{t.courses}</span>
      </div>
    </div>
  );
};

export default StatsBar;
